<template lang="html">
  <div class="actions-panel">
    <div class="buttons-group">
      <button
        :disabled="xlsExporting"
        @click="exportAction"
        class="vcv-button gray iconed xls"
        v-tooltip.top-center="$tr('invites.exportToExcel')"
      >
        <i class="fa fa-file-excel-o"/>
        <span>{{ $tr('invites.exportToExcel') }}</span>
      </button>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'action-panel',

    props: {
      exportAction: {
        type: Function,
        required: true
      }
    },

    computed: {
      xlsExporting () {
        return this.$store.state.search.xlsExportingInvites
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/queries.scss';

  .actions-panel {
    display: flex;
    align-self: center;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;

    @include tablet {
      .hint {
        display: none;
      }
    }

    @include mobile {
      .hint {
        display: none;
      }
    }
  }
</style>
